// Mirrors --ease-premium / --ease-elastic tokens in packages/config/src/tokens.css.
// Framer Motion needs a JS tuple; the CSS var powers the same curve in CSS transitions.
export const EASE_PREMIUM = [0.23, 1, 0.32, 1] as const;
export const EASE_ELASTIC = [0.175, 0.885, 0.32, 1.275] as const;
